import React , {useState} from 'react'
import { Stack, Box } from '@mui/material'
import ChannelCard from './ChannelCard'
import VideoCard from './VideoCard'
import Scrollbars from 'react-custom-scrollbars'
import LoadingBar from 'react-top-loading-bar'
function Videos({ videos , direction }) {
  const [progress, setProgress] = useState(100)

  return (

    <Scrollbars style={{  height:600 }} 
    thumbMinSize={30}>
      <LoadingBar 
      color="red"
      progress={progress}
      />
      <Stack direction={direction || "row"} flexWrap="wrap" justifyContent="start" gap={0.4} >
      
      {videos.map((item) => {
        return (
          <Box key={item.id.videoId} >
            {item.id.videoId && <VideoCard video={item} />}
            
            {item.id.channelId && <ChannelCard channelDetail={item} />}
          </Box>
        )
      })}
      
    </Stack>
    </Scrollbars>
  )
}

export default Videos
